// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mb__popup-area .mb__popup-box .mb__popup-item .mb__popup-contents.qrcode[data-v-e2efb836]{padding:0}", ""]);
// Exports
module.exports = exports;
